import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { IDeliveryAddressResponse } from 'dto/deliveryDto';

import deliveryService from 'service/delivery';

export const getDeliveryAddress = createAsyncThunk(
  'delivery/get',
  async (userId: string, thunkAPI) => {
    try {
      const { item, error, msg } = await deliveryService.get(userId);
      return { item, error, msg };
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return {
        item: null,
        error: true,
        msg: thunkAPI.rejectWithValue(message),
      };
    }
  },
);

export interface DeliveryInitType {
  loading: boolean;
  error: boolean;
  errorMsg: string;
  item: IDeliveryAddressResponse | null;
  addressIndex: string;
}

const initialState: DeliveryInitType = {
  loading: true,
  error: false,
  errorMsg: '',
  item: null,
  addressIndex: '1', // 결제 페이지에서 선택된 주소 인덱스
};

export const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDeliveryAddress.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });

    builder.addCase(getDeliveryAddress.fulfilled, (state, action) => {
      const {
        item,
        msg,
        error,
      }: {
        item: IDeliveryAddressResponse;
        msg: string;
        error: boolean;
      } = action.payload;

      const userDeliveryDataMessage = '데이터가 존재하지 않습니다.';
      // 아래 코드에 대한 에러처리
      // 1.배송지를 입력해서 저장한 유저가 있다면 IDeliveryAddressResponse 데이터를 바인딩합니다.고로 error: false
      // 2.반면 배송지를 한번도 입력하지 않은 유저 같은 경우 -> error:true && errorMsg:"데이터가 존재하지 않습니다."
      if (error && state.errorMsg !== userDeliveryDataMessage) {
        state.loading = false;
        state.error = true;
        state.errorMsg = msg;
        return;
      }

      state.loading = false;
      state.error = false;
      state.item = item;
      state.addressIndex = item?.main_address_index.toString() || '1';
    });
    builder.addCase(getDeliveryAddress.rejected, (state, action) => {
      const { msg }: any = action.payload;
      state.loading = false;
      state.error = true;
      state.errorMsg = msg;
    });
  },
});

export default deliverySlice.reducer;
